const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const AssetBench = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/index');
const Reinsurance = () => import(/* webpackChunkName: "asset" */'@/components/pages/asset/Reinsurance');

export default [
  {
    path: '/asset',
    name: 'asset',
    component: Layout,
    meta: {
      roles: ['SYS_CI_INSTANCE_QUERY', 'CRITICAL_PROTECTION_LIST_QUERY'],
      title: '备案登记',
      icon: 'asset',
    },
    children: [
      {
        path: 'reinsurance',
        name: 'reinsurance',
        meta: {
          roles: ['CRITICAL_PROTECTION_LIST_QUERY'],
          title: '重保责任书',
          componentName: 'Reinsurance',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '备案登记',
              path: ''
            },
            {
              name: '重保责任书',
              path: '/asset/reinsurance',
              isAsset: false
            }
          ]
        },
        component: Reinsurance
      },
      {
        path: 'asset-bench/:id',
        name: 'assetBench',
        meta: {
          roles: [],
          title: '资产列表',
          componentName: 'AssetBench',
          breadcrumb: [
            {
              name: '首页',
              path: '/home'
            },
            {
              name: '备案登记',
              path: ''
            },
            {
              name: '资产列表',
              path: '/asset/asset-bench/:id',
              isAsset: true
            }
          ]
        },
        component: AssetBench
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/asset.js